import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../../Hooks/use-user.hook';

export function UserLoggedGuard(props: PropsWithChildren) {
  const user = useUser();

  if (!user.data) {
    return <Navigate to='/login' replace />;
  }

  return props.children;
}
